






import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component({})
export default class Lightbox extends Vue {
    @Prop({ default: null }) value!: string | null;
    imageModal: string | null = null;

    @Watch('value')
    onValue() {
        this.imageModal = this.value;
    }
    @Watch('imageModal')
    onImageModal() {
        this.$emit('input', this.imageModal);
    }
}
